import { ISelectedDriver } from "@types";

export interface LinkedVehicleBaseData {
  assetId: string;
  assetName: string;
  routeId: string;
  startDateTime: string;
  startDateTimeUTC?: string;
}

/**
 * Monta o item único de `linkedVehicles` segundo o contrato do backend
 * (POST /v2/routes/rio/send/trip/{id}):
 *
 * - 1 motorista  → campos `driverId`/`driverName`/`profileId` na raiz do item.
 * - N motoristas → array `drivers` com `{ id, name, profileId? }` (schema diferente).
 *
 * O array `linkedVehicles` enviado ao backend SEMPRE contém apenas 1 item.
 */
export const buildLinkedVehicleItem = (
  base: LinkedVehicleBaseData,
  selectedDrivers: ISelectedDriver[]
) => {
  const baseItem = {
    assetId: base.assetId,
    assetName: base.assetName,
    routeId: base.routeId,
    startDateTime: base.startDateTime,
    ...(base.startDateTimeUTC ? { startDateTimeUTC: base.startDateTimeUTC } : {}),
  };

  if (selectedDrivers.length > 1) {
    return {
      ...baseItem,
      drivers: selectedDrivers.map((d) => ({
        id: d.id?.replace("prod-rio-users:", ""),
        name: d.name,
        profileId: d.uniqueId,
      })),
    };
  }

  const single = selectedDrivers[0];
  return {
    ...baseItem,
    driverId: single?.id?.replace("prod-rio-users:", ""),
    driverName: single?.name,
    profileId: single?.uniqueId,
  };
};
